import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AppleLogo } from 'assets/images/apple_logo.svg';
import { ReactComponent as GoogleLogo } from 'assets/images/google_logo.svg';
import { EPayBrand } from 'common/const';

interface IComponentProps {
  brand: EPayBrand;
  disabled: boolean;
  onClick: () => void;
}

const BRANDS: Record<EPayBrand, { name: string; Logo: typeof AppleLogo }> = {
  [EPayBrand.ApplePay]: { name: 'Apple Pay', Logo: AppleLogo },
  [EPayBrand.GooglePay]: { name: 'Google Pay', Logo: GoogleLogo },
};

/* Кнопка Apple Pay / Google Pay в фирменном виде (payment-buttons, R-1, O-13): чёрная, «Pay with» на языке
 *  страницы и знак бренда (логотип + «Pay»); знак не переводится. Отправляет форму оплаты. */
export const BrandPayButton: FC<IComponentProps> = ({ brand, disabled, onClick }) => {
  const { t } = useTranslation();
  const { name, Logo } = BRANDS[brand];
  const label = t('payment.tips.payWith');

  return (
    <div className="btn btn-pay-brand">
      <button type="submit" data-pay-brand={brand} aria-label={`${label} ${name}`} onClick={onClick} disabled={disabled}>
        <span>{label}</span>
        <span className="btn-pay-brand__mark">
          <Logo />
          Pay
        </span>
      </button>
    </div>
  );
};
